import React, {useContext} from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ArrowBack from '@material-ui/icons/ArrowBack';
import {useTranslation} from 'react-i18next';

import Topbar from 'components/Topbar';
import Context from 'utils/Context';

import 'index.css';
import './Account.scss';
import Profile from './Profile';
import Newsletters from './Newsletters';
import Localisation from './Localisation';
import MesSeances from './MesSeances';
import UsedCouponCodes from './UsedCouponCodes';
import Vod from './Vod';

const Account = ({params, ...others}) => {
  const {t} = useTranslation();
  const {appState, goTo} = useContext(Context);

  const shouldShowNewsletter = appState.conf.NEWSLETTER_ENABLED;

  const TABS = [
    {
      route: 'profil',
      component: Profile,
      label: 'mon-profil',
    },
    {
      route: 'seances',
      component: MesSeances,
      label: 'mes-seances',
    },
    {
      route: 'vod',
      component: Vod,
      label: 'mes-locations-vod',
    },
    {
      route: 'localisation',
      component: Localisation,
      label: 'ma-localisation',
    },
    {
      route: 'codes-promo',
      component: UsedCouponCodes,
      label: 'mes-codes-promo',
    },
  ];
  if (shouldShowNewsletter) {
    TABS.push({
      route: 'newsletters',
      component: Newsletters,
      label: 'mes-newsletters',
    });
  }

  const {page} = params;

  const {user} = appState;
  if (!user || !user.email) goTo('/');

  const handleTabChange = (e, index) => {
    goTo(`/mon-compte/${TABS[index].route}`);
  };

  const tabIndex = TABS.findIndex(tab => tab.route === page);
  const ContentComponent = TABS[tabIndex].component;

  return (
    <Container maxWidth="xl">
      <Topbar />
      <Container maxWidth="lg" disableGutters className={'account ' + page}>
        <div className="spacer" />
        <Button className="seance-btn" color="primary" size="small" variant="contained" onClick={() => goTo('/')}>
          <ArrowBack />
        </Button>
        <div className="spacer" />
        <Typography variant="h3" className="account-titre">
          {t('mon-compte')}
        </Typography>
        <Typography variant="h5" className="account-titre">
          {user.email}
        </Typography>
        <div className="spacer" />
        <Paper>
          <Tabs
            value={tabIndex}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="off"
            onChange={handleTabChange}
          >
            {TABS.map(tab => (
              <Tab key={tab.route} label={t(tab.label)} />
            ))}
          </Tabs>
        </Paper>
        <div className="spacer" />
        <ContentComponent params={params} {...others} />
      </Container>
    </Container>
  );
};

export default Account;
